export default __webpack_public_path__ + "resources/icons/n332-6571.png";